export default {  
  data: () => ({
    timerId: null,
    timerIdTimeout: null,
    timerSeconds: 0,
  }),
  
  beforeDestroy() {
    // stop Timer    
    this.$store.commit("setModeK", {modeK: Math.min(0.8, this.modeK)});
    clearInterval(this.timerId);
    this.timerId = null;
    clearTimeout(this.timerIdTimeout);
    this.timerIdTimeout = null;
  },

  methods: {
    // Таймер----------------------------------
    startTimer(timeout) {
      let that = this;
      this.timerSeconds = timeout;
      // повторить с интервалом 1 секунда
      this.timerId = setInterval(function() {
        --that.timerSeconds;
      }, 1000);
      // остановить таймер через timeout секунд
      this.timerIdTimeout = setTimeout(function() {
        // Time over
        that.timerSeconds = null;        
        that.$store.commit("setModeK", {modeK:0.8});
        clearInterval(that.timerId);
      }, timeout * 1000);
    },

    stopTimer() {
      this.timerSeconds = null;
      clearInterval(this.timerId);
      clearTimeout(this.timerIdTimeout);
    },
  },  
};
